<template>
  <div class="setting-box">
    <el-collapse-transition>
      <div class="dropdown-menu" v-show="show" @click="closeMenu">
        <!-- 头部：当前企业 + 切换 -->
        <div class="dd-head">
          <span class="dd-company">{{ currentCompanyName }}</span>
          <span class="dd-switch" @click.stop="switchCompany">
            <img src="@/assets/images/pro-plan/dd/ico-switch.png" alt="" />切换
          </span>
        </div>

        <!-- 版本状态条（免费版 / 专业版；未开启收费不显示） -->
        <!-- v-html 内部按钮通过事件冒泡捕获，内联 onclick 在 Vue 中无法调用组件方法 -->
        <div
          v-if="banner.cls"
          class="dd-banner pro_banner"
          :class="banner.cls"
          v-html="banner.html"
          @click="onBannerClick"
        ></div>

        <!-- 宫格入口 -->
        <div class="dd-grid">
          <div
            class="dd-grid-item"
            @click="changeHref('/usercenter/companyset')"
          >
            <img
              class="dd-ico"
              src="@/assets/images/pro-plan/dd/ico-company-set.png"
              alt=""
            />
            <span class="dd-txt">企业设置</span>
          </div>
          <div class="dd-grid-item" @click="changeHref('/usercenter/staff')">
            <img
              class="dd-ico"
              src="@/assets/images/pro-plan/dd/ico-staff.png"
              alt=""
            />
            <span class="dd-txt">员工管理</span>
          </div>
          <div
            class="dd-grid-item"
            @click="changeHref('/usercenter/businessrole')"
          >
            <img
              class="dd-ico"
              src="@/assets/images/pro-plan/dd/ico-role.png"
              alt=""
            />
            <span class="dd-txt">业务角色管理</span>
          </div>
        </div>

        <!-- 姓名行 -->
        <div class="dd-row dd-name-row" @click="dialogVisible = true">
          <span class="dd-row-txt">我在企业中的姓名</span>
          <span class="dd-row-right">
            <span class="dd-name">{{ myName }}</span>
            <img
              class="dd-edit"
              src="@/assets/images/pro-plan/dd/ico-edit.png"
              alt=""
            />
          </span>
        </div>

        <div class="dd-divider"></div>

        <!-- 专业版订单（STORY#3197 新增入口）——
             运营商未开启付费模式（isOpenCharge=false）时整条隐藏（禅道 #23424），
             与上方状态条同源同判：收费关闭时不出现任何专业版相关入口 -->
        <div
          v-if="showProOrderEntry"
          class="dd-row dd-menu-item"
          @click.stop="goProOrder"
        >
          <span class="dd-row-left">
            <img
              class="dd-row-ico"
              src="@/assets/images/pro-plan/dd/ico-order.png"
              alt=""
            />
            <span class="dd-row-txt">专业版订单</span>
          </span>
          <img
            class="dd-row-arrow"
            src="@/assets/images/pro-plan/dd/ico-arrow-right.png"
            alt=""
          />
        </div>

        <!-- 账号设置 -->
        <div
          class="dd-row dd-menu-item"
          @click="changeHref('/usercenter/accountset')"
        >
          <span class="dd-row-left">
            <img
              class="dd-row-ico"
              src="@/assets/images/pro-plan/dd/ico-account.png"
              alt=""
            />
            <span class="dd-row-txt">账号设置</span>
          </span>
          <img
            class="dd-row-arrow"
            src="@/assets/images/pro-plan/dd/ico-arrow-right.png"
            alt=""
          />
        </div>

        <div class="dd-logout-wrap">
          <div class="dd-logout" @click="handleLogout">退出登录</div>
        </div>
      </div>
    </el-collapse-transition>

    <!--  修改名称弹窗  -->
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      top="40vh"
      width="420px"
    >
      <span slot="title" style="color: #888; font-size: 16px"
        >修改姓名，以便让其它同事更好的认出您</span
      >
      <el-input
        v-model="myName"
        @input="handleInputName"
        placeholder=""
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleChangeName">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { windowHref, cutStrByCharLen, getStrCharLen } from "@/utils";
import { getStorage, removeStorage, setStorage } from "@/utils/storage";
import { editMyName, logout } from "@/api/request/snkd.user";
import { getCompanyPlanStatus } from "@/api/request/snkd.proPlan";
import { PRO_BANNER_TEXT, RENEW_TIP_DAYS } from "@/consts/proPlan";
import { formatDateDash, remainDays, isAreaClosed } from "@/utils/proPlan";

/**
 * 用户下拉框（STORY#3197 迁移自老端 frp_company_web）
 * 新增：版本状态条（免费版/专业版四种状态）+ 专业版订单入口 + 新样式
 */
export default {
  name: "SettingBox",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // 页头当前展示的姓名。作为下拉框「我在企业中的姓名」的同步来源：
    // 页头一旦刷新（改名成功、切换企业、重新拉企业信息），下拉框跟着更新，
    // 与老端 headerImg() 里同步 .dd_name 的做法一致（禅道 #23423）。
    userName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      companyInfo: null,
      currentCompanyName: "",
      dialogVisible: false,
      myName: "",
      banner: { cls: "", html: "" },
      // qualification 接口结果：用于状态条展示与「去升级/去续费」跳转分流
      qualification: null,
    };
  },
  computed: {
    companyId() {
      return (
        this.$route.query.companyId ||
        (getStorage("FARMINFO") || {}).companyId ||
        (this.companyInfo && this.companyInfo.companyId) ||
        ""
      );
    },
    // 是否展示「专业版订单」入口（禅道 #23424）
    // 判据与状态条完全一致：收费模式未开启、或资格接口失败拿不到数据时均隐藏，
    // 避免出现「没有状态条却有专业版入口」的割裂
    showProOrderEntry() {
      return !!(this.qualification && this.qualification.isOpenCharge);
    },
  },
  watch: {
    // 页头姓名变化 → 同步下拉框「我在企业中的姓名」（禅道 #23423）。
    // 覆盖改名成功、切换企业等所有会让页头刷新的路径。
    // 弹窗打开时不覆盖：此时 myName 是输入框内容，不能把用户正在输入的值冲掉。
    userName(val) {
      if (this.dialogVisible) return;
      if (val && val !== this.myName) this.myName = val;
    },
  },
  async mounted() {
    // 状态条独立渲染，避免企业信息接口异常时整块不展示
    await this.loadBanner();
    const companyInfo = await this.$store.dispatch("getCurCompanyInfo");
    this.companyInfo =
      (companyInfo && companyInfo.userCompany) || getStorage("COMPANYINFO");
    this.myName = this.companyInfo ? this.companyInfo.companyUserName : "";
    this.currentCompanyName = this.companyInfo
      ? this.companyInfo.companyName
      : "";
  },
  methods: {
    async loadBanner() {
      // 接口层返回后端 BaseResp：数据在 obj（qualification 接口）
      const res = await getCompanyPlanStatus({ companyId: this.companyId });
      if (res.respCode !== 0) return;
      this.qualification = res.obj || null;
      this.banner = this.buildBanner(this.qualification);
    },
    // 生成状态条（与老端 buildProBannerHtml 保持一致的四种状态）
    buildBanner(status) {
      if (!status || !status.isOpenCharge) {
        return { cls: "", html: "" };
      }
      const cfg = PRO_BANNER_TEXT;
      const layer = '<i class="pb-tex"></i><i class="pb-glow"></i>';
      const icon = (name) =>
        require(`@/assets/images/pro-plan/ico-${name}.png`);
      const titleImg = (name) =>
        require(`@/assets/images/pro-plan/title-${name}.png`);
      let cls = "";
      let html = layer;
      if (!status.rankType) {
        cls = "pb-free";
        html +=
          '<div class="pb-main"><div class="pb-head">' +
          `<img class="pb-icon" src="${icon("free")}" alt=""/>` +
          `<img class="pb-title-img" src="${titleImg("free")}" alt="${
            cfg.freeTitle
          }"/>` +
          "</div>" +
          `<p class="pb-desc">${cfg.freeDesc}</p></div>` +
          `<span class="pb-btn">${
            cfg.freeBtn
          }<img class="pb-btn-arrow" src="${require("@/assets/images/pro-plan/btn-arrow-free.svg")}" alt=""/></span>`;
      } else if (!status.isFailureTime) {
        cls = "pb-pro";
        // 到期日期用 yyyy-mm-dd（与老端 proPlanFormatDate、设计稿 1994:60 一致）
        const endStr =
          formatDateDash(status.professionalEndTime) + cfg.endTimeSuffix;
        // 是否进入「到期前 ≤30 天」：优先用后端 canRenew，缺失时前端按剩余天数判断
        const canRenew =
          typeof status.canRenew === "boolean"
            ? status.canRenew
            : remainDays(status.professionalEndTime, status.nowTime) <=
              RENEW_TIP_DAYS;
        if (!canRenew) {
          // 剩余 >30 天：到期日期 + 「权益尊享中」标签，无按钮（需求 §2，设计稿 1994-60）
          // 设计稿 1994-60：到期日期在**左侧标题下方**（pb-main 内），右侧仅「权益尊享中」标签。
          // 原先把日期放进 pb-right 与标签同行、靠右显示，与设计稿不符（禅道 Bug#23425-1）
          html +=
            '<div class="pb-main"><div class="pb-head">' +
            `<img class="pb-icon" src="${icon("pro")}" alt=""/>` +
            `<img class="pb-title-img" src="${titleImg("pro")}" alt="${
              cfg.proTitle
            }"/>` +
            "</div>" +
            `<p class="pb-desc">${endStr}</p></div>` +
            `<span class="pb-right"><span class="pb-tag">${cfg.proActiveTag}</span></span>`;
        } else {
          html +=
            '<div class="pb-main"><div class="pb-head">' +
            `<img class="pb-icon" src="${icon("pro")}" alt=""/>` +
            `<img class="pb-title-img" src="${titleImg("pro")}" alt="${
              cfg.proTitle
            }"/>` +
            "</div>" +
            `<p class="pb-desc">${endStr}${cfg.autoRenewSuffix}</p></div>` +
            `<span class="pb-btn">${
              cfg.proBtn
            }<img class="pb-btn-arrow" src="${require("@/assets/images/pro-plan/btn-arrow-pro.svg")}" alt=""/></span>`;
        }
      } else {
        cls = "pb-expired";
        html +=
          '<div class="pb-main"><div class="pb-head">' +
          `<img class="pb-icon" src="${icon("expired")}" alt=""/>` +
          `<img class="pb-title-img" src="${titleImg("expired")}" alt="${
            cfg.proTitle
          }"/>` +
          "</div>" +
          `<p class="pb-desc">${cfg.proExpiredDesc}</p></div>` +
          `<span class="pb-btn">${
            cfg.proBtn
          }<img class="pb-btn-arrow" src="${require("@/assets/images/pro-plan/btn-arrow-pro.svg")}" alt=""/></span>`;
      }
      return { cls, html };
    },
    handleInputName() {
      if (getStrCharLen(this.myName) > 20) {
        this.$message({ message: "人员姓名最多10字", type: "warning" });
        this.myName = cutStrByCharLen(this.myName, 10);
      }
    },
    // 状态条内「去升级 / 去续费」按钮：
    // 区域未开放线上支付 → 专业版权益页；其余 → 套餐购买页
    // 判定口径见 isAreaClosed（reasonCode 41004 优先，缺失时退回 qualified=false）
    // 「权益尊享中」标签（pb-tag）也可点 → 权益详情页（9 大权益说明）
    onBannerClick(e) {
      if (e.target.closest(".pb-tag")) {
        this.$router.push({
          path: "/proPlan/rightsDetail",
          query: { companyId: this.companyId },
        });
        this.closeMenu();
        return;
      }
      if (!e.target.closest(".pb-btn")) return;
      const areaClosed = isAreaClosed(this.qualification);
      this.$router.push({
        path: areaClosed ? "/proPlan/rights" : "/proPlan/index",
        query: { companyId: this.companyId },
      });
      this.closeMenu();
    },
    async handleChangeName() {
      const name = this.myName.trim();
      if (!name) {
        this.$message({ message: "请输入您的姓名", type: "warning" });
        return;
      }
      const res = await editMyName({
        companyId: this.companyInfo ? this.companyInfo.companyId : null,
        companyUserName: name,
      });
      if (res.respCode == 0) {
        this.$message({
          message: "您已成功修改在该企业中的姓名",
          type: "success",
        });
        this.$emit("change-my-name");
        this.dialogVisible = false;
      }
    },
    switchCompany() {
      this.$emit("swicth-company");
    },
    closeMenu() {
      this.$emit("update:show", false);
    },
    // 扩展端与其他入口保持 windowHref 跳老端页面的既有约定
    changeHref(url) {
      windowHref(url);
    },
    goProOrder() {
      this.$router.push({
        path: "/proPlan/orderList",
        query: { companyId: this.companyId },
      });
      this.closeMenu();
    },
    async handleLogout() {
      const res = await logout();
      if (res.respCode == 0) {
        const storage1 = getStorage("HARVESTFLAG") || false;
        const storage2 = getStorage("ROOTMODEID");
        localStorage.clear();
        removeStorage("ALLPOWER");
        setStorage("HARVESTFLAG", storage1);
        setStorage("ROOTMODEID", storage2);
        sessionStorage.removeItem("productStatistics");
        sessionStorage.removeItem("agriresStockList");
        sessionStorage.removeItem("regulatoryInfo");
        window.location.href = window.location.origin + "/login.html";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.setting-box {
  position: absolute;
  // 与顶部导航条的间距：设计稿 1877:620 定位在 y=90，而页头高 80，
  // 即间隙 10px（禅道 #23420-1）。原实现 85px 只留了 5px，下拉框顶部几乎贴住页头。
  // 老端 .account_pannel 同步为 90px
  top: 90px;
  right: 20px;
  width: 360px;
  z-index: 1000;
}
.dropdown-menu {
  width: 360px;
  box-sizing: border-box;
  padding: 17px 16px 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  color: #333;
  font-size: 14px;
}
.dd-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  .dd-company {
    max-width: 250px;
    font-size: 20px;
    font-weight: 700;
    color: #333;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .dd-switch {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #64c3a4;
    cursor: pointer;
    flex-shrink: 0;
    img {
      width: 15px;
      height: 14px;
    }
  }
}
// 宫格
.dd-grid {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.dd-grid-item {
  flex: 1;
  height: 90px;
  border-radius: 12px;
  background: #f7f9fb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0 5px;
  .dd-ico {
    width: 22px;
    height: 22px;
  }
  .dd-txt {
    font-size: 14px;
    color: #333;
    white-space: nowrap;
  }
}
// 行
.dd-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  border-radius: 12px;
  background: #f7f9fb;
  box-sizing: border-box;
  padding: 0 16px;
  cursor: pointer;
  .dd-row-txt {
    font-size: 15px;
    color: #666;
  }
  .dd-row-right {
    display: flex;
    align-items: center;
    .dd-name {
      font-size: 15px;
      color: #333;
    }
    .dd-edit {
      width: 18px;
      height: 18px;
      margin-left: 6px;
    }
  }
}
.dd-divider {
  height: 0;
  border-top: 1px solid #e9eef5;
  margin: 16px -16px;
}
.dd-menu-item {
  background: none;
  border-radius: 0;
  padding: 0;
  .dd-row-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .dd-row-ico {
    width: 22px;
    height: 22px;
  }
  .dd-row-arrow {
    width: 18px;
    height: 18px;
  }
  .dd-row-txt {
    color: #333;
  }
}
.dd-logout-wrap {
  margin-top: 16px;
  .dd-logout {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border-radius: 12px;
    background: #f7f9fb;
    color: #ff5252;
    font-size: 15px;
    cursor: pointer;
    &:hover {
      background: #f2f4f8;
    }
  }
}
</style>
